import type { VinDetail } from '@/api/schemas';
import { NOT_AVAILABLE } from '@/lib/display';

export type FeatureRow = { label: string; col2: string[]; col3: string[] };

const notAvailable = (): FeatureRow['col2'] => [NOT_AVAILABLE];

export function getFeatureRows(detail: VinDetail | null): FeatureRow[] {
  const v = (value: string | null | undefined) => value || NOT_AVAILABLE;

  return [
    {
      label: 'Model Family Description',
      col2: [v(detail?.modelFamilyDescription)],
      col3: [v(detail?.modelCode), v(detail?.modelSeriesCode)],
    },
    {
      label: 'Cab Configuration',
      col2: [v(detail?.cabConfiguration), v(detail?.cabType)],
      col3: notAvailable(),
    },
    {
      label: 'Transmission',
      col2: [
        v(detail?.transmission),
        v(detail?.transmissionManufacturer),
        v(detail?.transmissionModel),
      ],
      col3: notAvailable(),
    },
    {
      label: 'Engine Feature',
      col2: [
        v(detail?.engineManufacturer),
        v(detail?.engineFeatureDescription),
        v(detail?.engineModel),
        v(detail?.engineBrake),
        v(detail?.horsepower),
        v(detail?.engineSerialNumber),
      ],
      col3: [v(detail?.engineFeatureCode)],
    },
    {
      label: 'Front Axel',
      col2: [v(detail?.frontAxleManufacturer), v(detail?.frontAxleModel)],
      col3: [v(detail?.axleConfiguration)],
    },
    {
      label: 'Rear Axel',
      col2: [v(detail?.rearAxleManufacturer), v(detail?.rearAxleModel)],
      col3: [v(detail?.rearAxle)],
    },
    { label: 'Air Dryer', col2: notAvailable(), col3: notAvailable() },
    {
      label: 'Lube, Front Wheel Bearing',
      col2: notAvailable(),
      col3: notAvailable(),
    },
    { label: 'Lube, Rear Axel', col2: notAvailable(), col3: notAvailable() },
    { label: 'No Idle System', col2: notAvailable(), col3: notAvailable() },
    { label: 'Driveline System', col2: notAvailable(), col3: notAvailable() },
    { label: 'PTO', col2: notAvailable(), col3: notAvailable() },
    {
      label: 'Front Suspension',
      col2: [v(detail?.suspensionFront)],
      col3: notAvailable(),
    },
    {
      label: 'Rear Suspension',
      col2: [v(detail?.suspensionRear)],
      col3: notAvailable(),
    },
    {
      label: 'Fuel Water Separator',
      col2: notAvailable(),
      col3: notAvailable(),
    },
    { label: 'Heater Auxiliary', col2: notAvailable(), col3: notAvailable() },
    { label: '5th Wheel', col2: notAvailable(), col3: notAvailable() },
  ];
}
